import { render, staticRenderFns } from "./VDesignTaskModal.vue?vue&type=template&id=0b5fa8d2&"
import script from "./VDesignTaskModal.vue?vue&type=script&lang=ts&"
export * from "./VDesignTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignTaskModal.vue?vue&type=style&index=0&id=0b5fa8d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports